import PropTypes from 'prop-types'
import React, { useContext } from 'react'

import ButtonRounded from 'components/ButtonRounded'
import { LocalizationContext } from 'contexts/Localization'
import { ResizeContext } from 'contexts/Resize'
import { H2 } from 'styles/components/typography'

import HowItWorksFeature from './components/HowItWorksFeature'
import {
  SectionWrapperStyled,
  SectionCover,
  ButtonBlock,
  SliderWrapper,
  SliderMobileStyled,
} from './styles'

/**
 * HowItWorks
 *
 * @param {object} props - properties of component
 * @returns {node} HowItWorks
 */
const HowItWorks = ({ data, coverUrl, link }) => {
  const { mobile } = useContext(ResizeContext)
  const { dict, locale } = useContext(LocalizationContext)

  return (
    <SectionWrapperStyled
      withOverlay={true}
      beforeElement={<SectionCover {...{ coverUrl }} />}
    >
      <H2 dangerouslySetInnerHTML={{ __html: data.title }} />

      {mobile ? (
        <SliderWrapper>
          <SliderMobileStyled isWhite={true} amount={data.list.length}>
            {data.list.map((item, key) => (
              <div key={key}>
                <HowItWorksFeature item={item} />
              </div>
            ))}
          </SliderMobileStyled>
        </SliderWrapper>
      ) : (
        <div className="row">
          {data.list.map((item, key) => (
            <div key={key} className="col-4">
              <HowItWorksFeature item={item} />
            </div>
          ))}
        </div>
      )}

      <ButtonBlock>
        <ButtonRounded
          as="Link"
          to={link.link(locale)}
          asPath={link.as(locale)}
          bgClassName="bg--green"
        >
          {dict.buttons.learn_more}
        </ButtonRounded>
      </ButtonBlock>
    </SectionWrapperStyled>
  )
}

HowItWorks.propTypes = {
  data: PropTypes.object.isRequired,
  link: PropTypes.object.isRequired,
  coverUrl: PropTypes.string,
}

HowItWorks.defaultProps = {
  coverUrl: '',
}

export default HowItWorks
